import { apiSlice } from "../../app/api/apiSlice";

export const reportApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getPatientReport: builder.mutation({
            query: (credentials) => ({
                url: `report/patient-visit?date_range=${credentials.dateRangeValue}&from_date=${credentials.from_date}&to_date=${credentials.to_date}&patient_id=${credentials.patient_id}&city=${credentials.city}&state=${credentials.state}&visit_type=${credentials.visit_type}&provider_id=${credentials.provider_id}&location=${credentials.location}&status=${credentials.status}`,
                method: "GET",
            }),
        }),
        getProviderActivityReport: builder.mutation({
            query: (credentials) => ({
                url: `report/provider-activity?provider_id=${credentials.provider_id}&provider_type=${credentials.provider_type}&date_range=${credentials.date_range}&from_date=${credentials.from_date}&to_date=${credentials.to_date}&state=${credentials.state}&status=${credentials.status}`,
                method: "GET",
            }),
        }),
        getRevenueReport: builder.mutation({
            query: (credentials) => ({
                url: `report/revenue?provider_id=${credentials.provider_id}&provider_type=${credentials.provider_type}&date_range=${credentials.date_range}&from_date=${credentials.from_date}&to_date=${credentials.to_date}&visit_type=${credentials.visit_type}&patient_id=${credentials.patient_id}&status=${credentials.status}`,
                method: "GET",
            }),
        }),
        getAppointmentCancellationReport: builder.mutation({
            query: (credentials) => ({
                url: `report/cancellation?provider_id=${credentials.provider_id}&provider_type=${credentials.provider_type}&date_range=${credentials.date_range}&from_date=${credentials.from_date}&to_date=${credentials.to_date}&visit_type=${credentials.visit_type}&cancelled_reason=${credentials.cancelled_reason}&is_selectall_cancelled_reason=${credentials.is_selectall_cancelled_reason}`,
                method: "GET",
            }),
        }),
        getTemplates: builder.mutation({
            query: (credentials) => ({
                url: `datastore/get-template`,
                method: "GET",
            }),
        }),
        createTemplates: builder.mutation({
            query: (credentials) => ({
                url: `datastore/create-template`,
                method: "POST",
                body: { ...credentials },
            }),
        }),
        updateTemplates: builder.mutation({
            query: (credentials) => ({
                url: `/datastore/update-template`,
                method: "POST",
                body: { ...credentials },
            }),
        }),
        getTemplatesByColumns: builder.mutation({
            query: (credentials) => ({
                url: `/datastore/get-templates-by-columns`,
                method: "POST",
                body: { ...credentials },
            }),
        }),
        getTemplateById: builder.mutation({
            query: (credentials) => ({
                url: `/datastore/get-template-by-id`,
                method: "POST",
                body: { ...credentials },
            }),
        }),
        getAllUserReports: builder.mutation({
            query: (credentials) => ({
                url: `/user-reports/get-user-reports`,
                method: "GET",
            }),
        }),
        getReportById: builder.mutation({
            query: (credentials) => ({
                url: `/user-reports/get-report/${credentials}`,
                method: "GET",
            }),
        }),
        creteUserReport: builder.mutation({
            query: (credentials) => ({
                url: `/user-reports/create-report`,
                method: "POST",
                body: { ...credentials },
            }),
        }),
        updateUserReport: builder.mutation({
            query: (credentials) => ({
                url: `/user-reports/update-report`,
                method: "POST",
                body: { ...credentials },
            }),
        }),
        getOverduePatientReport: builder.mutation({
            query: (credentials) => ({
                url: `/report/overdue?date_range=${credentials?.date_range}&from_date=${credentials.from_date}&to_date=${credentials.to_date}&city=${credentials.city}&visit_type=${credentials.visit_type}&patient_id=${credentials.patient_id}&location=${credentials.location}&provider_id=${credentials.provider_id}`,
                method: "GET",
            }),
        }),
        getNewPatientReport: builder.mutation({
            query: (credentials) => ({
                url: `/report/new-patients?date_range=${credentials.dateRangeValue}&from_date=${credentials.from_date}&to_date=${credentials.to_date}&city=${credentials.city}&state=${credentials.state}&location=${credentials.location}`,
                method: "GET",

            }),
        }),
        getDailyMileageReport: builder.mutation({
            query: (credentials) => ({
                url: `/report/miledge-report?date_range=${credentials.date_range}&from_date=${credentials.from_date}&to_date=${credentials.to_date}&state=${credentials.state}&provider_id=${credentials.provider_id}&provider_type=${credentials.provider_type}`,
                method: "GET",

            }),
        }),
        getNoShowReport: builder.mutation({
            query: (credentials) => ({
                url: `/report/noshow-report?date_range=${credentials.date_range}&from_date=${credentials.from_date}&to_date=${credentials.to_date}&provider_id=${credentials.provider_id}&visit_type=${credentials.visit_type}&patient_id=${credentials.patient_id}`,
                method: "GET",

            }),
        }),
        getPatientZipcodeReport: builder.mutation({
            query: (credentials) => ({
                url: `/report/patient-zip-code-report?zip=${credentials.zip}`,
                method: "GET",

            }),
        }),
        getPatientByZipcode: builder.mutation({
            query: (credentials) => ({
                url: `/report/patient-by-zip?zip=${credentials.zip}`,
                method: "GET",
            }),
        }),
        getAllTables: builder.mutation({
            query: (credentials) => ({
                url: `dashboard/tables`,
                method: "GET",
            }),
        }),
        getTableDataByName: builder.mutation({
            query: (credentials) => ({
                url: `dashboard/get-table-by-name`,
                method: "POST",
                body: { ...credentials },
            }),
        }),
        filterTableData: builder.mutation({
            query: (credentials) => ({
                url: `dashboard/filter`,
                method: "POST",
                body: { ...credentials },
            }),
        }),
        createDashboard: builder.mutation({
            query: (credentials) => ({
                url: `dashboard/create-dashboard`,
                method: "POST",
                body: { ...credentials },
            }),
        }),
        updateDashboard: builder.mutation({
            query: (credentials) => ({
                url: `dashboard/update-dashboard`,
                method: "POST",
                body: { ...credentials },
            }),
        }),
        getAllDashboards: builder.mutation({
            query: (credentials) => ({
                url: `dashboard/get-dashboards`,
                method: "GET",
            }),
        }),
        getDashboardById: builder.mutation({
            query: (credentials) => ({
                url: `dashboard/get-dashboard/${credentials}`,
                method: "GET",
            }),
        }),
        getAllSharedReports : builder.mutation({
            query:() =>({
                url: `/report/skorboard/shared-reports`,
                method: "GET",
            } ),
        }),
        getAllSharedDashboards: builder.mutation({
            query: () => ({
                url: `/report/skorboard/shared-dashboards`,
                method: "GET",
            }),
        }),
        getPublishLink: builder.mutation({
            query: (id) => ({
                url: `/report/skorboard/shared-reports/${id}/publish-link`,
                method: "GET",
            }),
        }),
        getDashboardPublishLink: builder.mutation({
            query: (id) => ({
                url: `/report/skorboard/shared-dashboards/${id}/publish-link`,
                method: "GET",
            }),
        }),

    }),
});

export const {
    useGetPatientReportMutation,
    useGetProviderActivityReportMutation,
    useGetRevenueReportMutation,
    useGetAppointmentCancellationReportMutation,
    useGetTemplatesMutation,
    useCreateTemplatesMutation,
    useUpdateTemplatesMutation,
    useGetTemplatesByColumnsMutation,
    useGetAllUserReportsMutation,
    useGetReportByIdMutation,
    useCreteUserReportMutation,
    useUpdateUserReportMutation,
    useGetTemplateByIdMutation,
    useGetOverduePatientReportMutation,
    useGetNewPatientReportMutation,
    useGetDailyMileageReportMutation,
    useGetNoShowReportMutation,
    useGetAllTablesMutation,
    useGetTableDataByNameMutation,
    useFilterTableDataMutation,
    useCreateDashboardMutation,
    useGetAllDashboardsMutation,
    useUpdateDashboardMutation,
    useGetDashboardByIdMutation,
    useGetPatientZipcodeReportMutation,
    useGetPatientByZipcodeMutation,
    useGetAllSharedReportsMutation,
    useGetAllSharedDashboardsMutation,
    useGetPublishLinkMutation,
    useGetDashboardPublishLinkMutation
} = reportApiSlice;
